import { IModel, Model } from '../Model';
import { AuthRoleModel, IAuthRoleModel } from './AuthRoleModel';
import { IUserModel, UserModel as SecurityUserModel } from './UserModel';

export interface IAuthUserModel extends IModel {
  authUserId: number;
  authUserName: string | undefined;
  roles: IAuthRoleModel[];
  user: IUserModel;
}

export class AuthUserModel extends Model implements IAuthUserModel {
  authUserId: number;
  authUserName: string | undefined;
  roles: IAuthRoleModel[];
  user: IUserModel;

  constructor(params: Partial<IAuthUserModel>) {
    super(params);
    const {
      authUserId = 0,
      authUserName = undefined,
      roles = [],
      user = {},
    } = params;

    this.authUserId = authUserId;
    this.authUserName = authUserName;

    this.roles = new Array<IAuthRoleModel>();
    if (roles && roles.length && roles.length > 0) {
      roles.forEach((value) => {
        this.roles.push(new AuthRoleModel(value));
      });
    }
    this.user = new SecurityUserModel(user);
  }
}
